import * as React from 'react';
import { AMPMSelectWrapper } from './DateTimeRangePicker.styled';
import { ReactComponent as RightIcon } from '../../../assets/icons/base/chevron-right.svg';
import { ReactComponent as LeftIcon } from '../../../assets/icons/base/chevron-left.svg';

interface IAMPMSelect {
  value: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onChange: Function;
}

const AMPMSelect = ({ value, onChange }: IAMPMSelect) => {
  return (
    <AMPMSelectWrapper>
      <LeftIcon onClick={() => onChange(!value)} style={{ cursor: 'pointer' }} />
      <span style={{ flex: 1, cursor: 'pointer' }}>
        {value ? 'AM' : 'PM'}
      </span>
      <RightIcon onClick={() => onChange(!value)} style={{ cursor: 'pointer' }} />
    </AMPMSelectWrapper>
  );
};

export default AMPMSelect;
